import { z } from 'zod';
/**
 * Ucty, skupiny a pozvanky.
 *
 * Kazdy clovek ma ucet (e-mail + heslo) a osobni skupinu. Sablona, obchody
 * a nakupy patri skupine; do sdilene skupiny se pridava pres jednorazovy
 * odkaz poslany treba v Messengeru. E-maily se neposilaji vubec.
 */
export const PASSWORD_MIN = 10;
/** Jak dlouho plati odkaz s pozvankou. */
export const INVITE_DAYS = 7;
export const EmailSchema = z.string().trim().toLowerCase().pipe(z.email().max(254));
export const PasswordSchema = z.string().min(PASSWORD_MIN).max(200);
export const PersonNameSchema = z.string().trim().min(1).max(60);
export const GroupNameSchema = z.string().trim().min(1).max(60);
/** Tokeny v odkazech jsou base64url, generuje je server. */
export const TokenSchema = z.string().regex(/^[A-Za-z0-9_-]{16,100}$/);
export const UserSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
});
export const GroupRoleSchema = z.enum(['owner', 'member']);
export const MemberSchema = z.object({
    userId: z.uuid(),
    name: z.string(),
    role: GroupRoleSchema,
    joinedAt: z.iso.datetime(),
});
export const GroupSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    /** Osobni skupina vznika s uctem, neda se opustit ani do ni nikoho pozvat. */
    personal: z.boolean(),
    createdAt: z.iso.datetime(),
    /** Role prihlaseneho uzivatele v teto skupine. */
    role: GroupRoleSchema,
    members: z.array(MemberSchema),
});
export const MeResponseSchema = z.object({
    user: UserSchema,
    groups: z.array(GroupSchema),
});
export const LoginInputSchema = z.object({
    email: EmailSchema,
    // Pri prihlaseni se delka nekontroluje — heslo z drivejsich pravidel musi projit.
    password: z.string().min(1).max(200),
});
/** Registrace jde jen s pozvankou. Prvni ucet vznika pres pozvanku z CLI. */
export const RegisterInputSchema = z.object({
    name: PersonNameSchema,
    email: EmailSchema,
    password: PasswordSchema,
    inviteToken: TokenSchema,
});
export const ProfilePatchSchema = z.object({ name: PersonNameSchema });
export const PasswordChangeSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: PasswordSchema,
});
export const PasswordResetSchema = z.object({
    token: TokenSchema,
    newPassword: PasswordSchema,
});
export const GroupInputSchema = z.object({ name: GroupNameSchema });
export const GroupsResponseSchema = z.object({ groups: z.array(GroupSchema) });
/** Co uvidi clovek, ktery otevre odkaz s pozvankou, jeste pred prihlasenim. */
export const InvitePreviewSchema = z.object({
    /** Podle id pozna prihlaseny clen, ze ve skupine uz je. */
    groupId: z.uuid().nullable(),
    /** null = pozvanka jen k zalozeni uctu, bez skupiny (vytvari ji CLI). */
    groupName: z.string().nullable(),
    inviterName: z.string().nullable(),
    memberNames: z.array(z.string()),
    expiresAt: z.iso.datetime(),
});
export const InviteInputSchema = z.object({
    /** „Pro koho" — jen aby se pozvanka v seznamu dala poznat. */
    label: z.string().trim().max(60).nullable().default(null),
});
/** Token se vraci jen jednou, pri vytvoreni. V databazi je jen jeho hash. */
export const InviteCreatedSchema = z.object({
    id: z.uuid(),
    token: z.string(),
    label: z.string().nullable(),
    expiresAt: z.iso.datetime(),
});
export const PendingInviteSchema = z.object({
    id: z.uuid(),
    label: z.string().nullable(),
    createdAt: z.iso.datetime(),
    expiresAt: z.iso.datetime(),
    createdByName: z.string().nullable(),
});
export const InvitesResponseSchema = z.object({ invites: z.array(PendingInviteSchema) });
/** Po prijeti pozvanky se klient prepne do skupiny, do ktere se pridal. */
export const AcceptInviteResponseSchema = z.object({ groupId: z.uuid().nullable() });
//# sourceMappingURL=auth.js.map